import React, { useState, Fragment } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useSelector, useDispatch } from 'react-redux'
import {TOGGLE_MENU_VISIBILITY} from '../state/uiActions'

import MapConfigContainer from './MapConfigContainer'
import ViewportMenuContainer from './ViewportMenuContainer';
import ViewportLayersMenu from '../menu/ViewportLayersMenu'


export default function MainMenuContainer(props) {

  const dispatch = useDispatch(); 
  //const [showViewport, setShowViewport] = useState(true); 
  const menuVisible = useSelector((state) => state.ui.menuVisible)
  const map = useSelector((state) => state.ui.map)

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  
  const handleClose = () => {
    //setShowViewport(false);
    dispatch({ type: TOGGLE_MENU_VISIBILITY })
  }
  //const handleShow = () => setShowViewport(true);

  // <Offcanvas.Title></Offcanvas.Title>
  return (
    <Offcanvas id="sidebar" show={menuVisible} onHide={handleClose} 
               scroll={true} backdrop={false}>
      <Offcanvas.Header closeButton className="menuSwitcher rounded button">
          MENÜ
      </Offcanvas.Header>

      <Offcanvas.Body className="menuBody">
          <div className="menuItemCollapse ml-0 d-grid gap-2">
            <Button variant="outline-secondary"
                    onClick={() => setOpen1(!open1)}>
              {/*<i className="fas fa-running"></i>&nbsp;*/} TÚRACSOPORTOK
            </Button>
            <Collapse in={open1}>
              <div id="itemsCollapse" className="ml-0">            
                <ViewportMenuContainer 
                  location={props.location} browserHistory={props.browserHistory} />
              </div>
            </Collapse>
          </div> 
          
          <div className="menuItemCollapse ml-0 d-grid gap-2">
            <Button variant="outline-secondary"
                    onClick={() => setOpen2(!open2)}>
              {/*<i className="fas fa-route"></i>&nbsp;*/} ÚTVONAL
            </Button>
            <Collapse in={open2}>
              <div className="ml-0 menu-item-block">               
                <ViewportLayersMenu
                  map={map} location={location}
                />
              </div>
            </Collapse>
          </div>

          <div className="menuItemCollapse ml-0 d-grid gap-2">
            <Button variant="outline-secondary"
                    onClick={() => setOpen3(!open3)}>
              {/*<i className="fas fa-route"></i>&nbsp;*/} TÉRKÉP
            </Button>
            <Collapse in={open3}>
              <div className="ml-0 menu-item-block">            
                <MapConfigContainer map={map} location={location}
                />
              </div>
            </Collapse>
          </div>

      </Offcanvas.Body>
    </Offcanvas>
  ) ;

}